import React from "react";

import "./VirusPartLabels.scss";

export default React.forwardRef(function VirusPartLabels(
  { currentVirusPart },
  ref
) {
  return (
    <div className={`virus-part-labels ${currentVirusPart}`}>
      <div className="virus-part-labels__container" ref={ref}>
        <div
          className={`virus-part-labels__label virus-part-labels__label--genes ${
            currentVirusPart === "genes" ? "active" : null
          }`}
        >
          GENES
        </div>
        <div
          className={`virus-part-labels__label virus-part-labels__label--proteins ${
            currentVirusPart === "proteins" ? "active" : null
          }`}
        >
          PROTEINS
        </div>
        <div
          className={`virus-part-labels__label virus-part-labels__label--envelope ${
            currentVirusPart === "envelope" ? "active" : null
          }`}
        >
          ENVELOPE
        </div>
      </div>
    </div>
  );
});
